import { render, staticRenderFns } from "./CurrencyRate.vue?vue&type=template&id=c5a35d7c&"
import script from "./CurrencyRate.vue?vue&type=script&lang=js&"
export * from "./CurrencyRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports